// extracted by mini-css-extract-plugin
module.exports = {"providers":"providers-module--providers--vH4DE"};